(function FixedHeader($, Adzuki)
{
	"use strict";
	// Hide Header on on scroll down

	$(document)
		.ready(
			function documentReady() {
				var $body         = $('body');
				var $header       = $('#header');
				var $contactBtn   = $('.contact-btn');
				var $contactTab   = $('#contact');
				var $closeContact = $('.close-contact');
				var navbarHeight  = $header.height();
				var lastScrollTop = 0;
				var delta         = 5;
				var didScroll;
				// var $searchBtn     = $('.search-btn');
				// var $closeSearch   = $('.close-search');

				$body.removeClass('preload');

				// $searchBtn.click(
				// 	function toggleSearchForm(e) {
				// 		e.preventDefault();
				// 		$body.toggleClass('search-open');
				// 	}
				// );

				// $closeSearch.click(
				// 	function toggleSearchForm(e) {
				// 		e.preventDefault();
				// 		$body.removeClass('search-open');
				// 	}
				// );

				$contactBtn.click(
					function toggleSearchForm(e) {
						e.preventDefault();
						$body.toggleClass('contact-open');
					}
				);

				$contactTab.click(
					function toggleSearchForm(e) {
						$body.toggleClass('contact-open');
					}
				);

				$closeContact.click(
					function toggleSearchForm(e) {
						e.preventDefault();
						e.stopPropagation();
						$body.removeClass('contact-open');
					}
				);

				$(window).resize(
					function adjustPadding() {
						$body.css("padding-top", $header.height());
					}
				).resize();

				$(window).scroll(function checkScroll(event) {
					didScroll = true;
				});

				setInterval(function setScroll() {
					if (didScroll) {
						displayHeader();
						didScroll = false;
					}
				}, 250);

				function displayHeader() {
					var st                    = $(window).scrollTop();
					var ignore_display_header = $('#ignore_display_header').val();

					// Make sure they scroll more than delta
					if (Math.abs(lastScrollTop - st) <= delta) {
						return;
					}

					// If they scrolled down and are past the navbar, add class .nav-up.
					// This is necessary so you never see what is "behind" the navbar.
					if (st > lastScrollTop && st > navbarHeight) {
						if (!$header.find('.dropdown').is('.open')) {
							// Scroll Down
							$('#header').removeClass('nav-down').addClass('nav-up');
						}
					} else if (st + $(window).height() < $(document).height()) {
						// Scroll Up
						if (ignore_display_header === '1') { // re-displaying header temporarily disabled
							return;
						}

						if (st < 100) {
							// only display the header once we are back to the top of the screen
							$('#header').removeClass('nav-up').addClass('nav-down');
						}
					}

					lastScrollTop = st;
				}
			}
		)
	;
}(jQuery, window.Adzuki || {}));
